import { render, staticRenderFns } from "./SquareIconButton.vue?vue&type=template&id=6bb9196b&scoped=true&"
import script from "./SquareIconButton.vue?vue&type=script&lang=ts&"
export * from "./SquareIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./SquareIconButton.vue?vue&type=style&index=0&id=6bb9196b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9196b",
  null
  
)

export default component.exports